angular.module('impactx.user')
    .directive('ixDelegationSelection', function() {
        return {
            scope: {
                delegations: "=",
                allowMultipleDelegate: "=",
                trns: "=",
                dialogData: "=",
                requiredLabel: "@",
                noSelectedItemLabel: "@",
                activateDelegateLabel: "@",
                addNewDelegationLabel: "@",
                readOnly: "=",
                forProfile: "=",
                forUser: "="
            },
            controller: 'DelegationCtrl',
            controllerAs: 'delegationCtrl',
            restrict: 'E',
            templateUrl: 'shared/user/templates/delegationselection.tmpl.html',
            transclude: true
        };
    });